var templatePath = 'template/layouts/';
var routeConstants = {
    /* === Add states descriptions here === */

    'index': {
        url: '/:dealerId?ConfirmationCode',
        controller: ['$state', function ($state) {
            if ($state.params.ConfirmationCode) $state.go('byConfirmationCode', {code: $state.params.ConfirmationCode})
            else $state.go('wellcome', $state.params)
        }]
    },
    'wellcome': {
        url: '/wellcome?ConfirmationCode',
        templateUrl: templatePath + 'wellcome',
        controller: 'WellcomeCtrl'
    },
    'byConfirmationCode': {
        url: '/confirmationCode/:code',
        controller: 'ByConfirmationCodeController'
    },
    'searchresults': {
        url: '/searchresults',
        params: {
            byConfirmationCode: null,
        },
        templateUrl: templatePath + 'search-result',
        controller: 'SearchResultsCtrl'
    },
    'checkhealth': {
        url: '/checkhealth',
        templateUrl: templatePath + 'vehicle-check-health',
        controller: 'VehicleCheckHealthCtrl',
        params: {
            skip: false
        }
    },
    'summary': {
        url: '/vehiclesummary',
        templateUrl: templatePath + 'appointment-summary',
        controller: 'AppointmentSummaryCtrl'
    },
    'summary.survey': {
        url: '/survey/:serviceId/:templateId',
        templateUrl: templatePath + 'survey',
        controller: 'SurveyCtrl',
        params: {
            name: null
        }
    },
    'bookappointment': {
        url: '/bookappointment',
        templateUrl: templatePath + 'book-appointment',
        controller: 'BookAppointmentCtrl'
    },
    'bookappointment.survey': {
        url: '/survey/:serviceId/:templateId',
        templateUrl: templatePath + 'survey',
        controller: 'SurveyCtrl',
        params: {
            name: null
        }
    },
    'bookappointment.updates': {
        url: '/updates',
        templateUrl: templatePath + 'vehicle-updates',
        controller: 'VehicleUpdatesCtrl'
    },
    'bookappointment.concerns': {
        url: '/concerns',
        templateUrl: templatePath + 'customer-concerns',
        controller: 'CustomerConcernsCtrl'
    },
    'bookappointment.required': {
        url: '/required',
        templateUrl: templatePath + 'factory-required',
        controller: 'FactoryRequiredCtrl'
    },
    'bookappointment.recommended': {
        url: '/recommended',
        templateUrl: templatePath + 'dealer-recommended',
        controller: 'DealerRecommendedCtrl',
        params: {
            startPage: 'wellcome'
        }
    },
    'bookappointment.schedule': {
        url: '/schedule',
        templateUrl: templatePath + 'schedule',
        controller: 'ScheduleCtrl',
        params: {
            startPage: 'wellcome'
        }
    },
    'bookappointment.noservices': {
        url: '/services-required',
        templateUrl: templatePath + 'services-required',
        controller: 'ServicesRequiredCtrl'
    },
    'createcustomer': {
        url: '/createcustomer',
        templateUrl: templatePath + 'createcustomer',
        controller: 'CreateCustomerCtrl',
        controllerAs: 'ctrl',
        params: {
            loader: null,
            vehicle: null,
            odometer: null
        }
    },
    'createcustomer.manufacturer': {
        url: '/manufacturer',
        templateUrl: templatePath + 'createcustomer-manufacturer',
        controller: 'CreateCustomerManufacturerCtrl',
        controllerAs: 'subctrl'
    },
    'createcustomer.year': {
        url: '/year',
        templateUrl: templatePath + 'createcustomer-year',
        controller: 'CreateCustomerYearCtrl',
        controllerAs: 'subctrl',
        params: {
            loader: null
        }
    },
    'createcustomer.model': {
        url: '/model',
        templateUrl: templatePath + 'createcustomer-model',
        controller: 'CreateCustomerModelCtrl',
        controllerAs: 'subctrl'
    },
    'createcustomer.transmission': {
        url: '/transmission',
        templateUrl: templatePath + 'createcustomer-transmission',
        controller: 'CreateCustomerTransmissionCtrl',
        controllerAs: 'subctrl'
    },
    'createcustomer.engine': {
        url: '/transmission',
        templateUrl: templatePath + 'createcustomer-engine',
        controller: 'CreateCustomerEngineCtrl',
        controllerAs: 'subctrl'
    },
    'createcustomer.drivetrain': {
        url: '/drivetrain',
        templateUrl: templatePath + 'createcustomer-drive-train',
        controller: 'CreateCustomerDriveTrainCtrl',
        controllerAs: 'subctrl'
    },
    'overview': {
        url: '/overview',
        templateUrl: templatePath + 'createcustomer-overview',
        controller: 'CreateCustomerOverViewCtrl'
    },
    'confirmation': {
        url: '/confirmation',
        templateUrl: templatePath + 'confirmation',
        controller: 'ConfirmationCtrl'
    },
    'cancel': {
        url: '/cancel',
        templateUrl: templatePath + 'cancel-appointment',
        controller: 'CancelAppointmentCtrl'
    },
    /* === System state if url does not much any defined states === */
    'otherwise': {
        url: "*path",
        controller: 'OtherwiseCtrl'
    }
};

module.exports = routeConstants;


